module.exports = __webpack_public_path__ + "static/media/IMG_6106.bfb42cec.jpg";